var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-15 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13030",
    "data-name": "Group 13030",
    transform: "translate(16 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12977",
    "data-name": "Path 12977",
    d: "M28,27.529V24.706m0,2.824v2.824m0-2.824h9a2.916,2.916,0,0,0,3-2.824M28,27.529H19a2.916,2.916,0,0,1-3-2.824m24,0v8.471A2.916,2.916,0,0,1,37,36H19a2.916,2.916,0,0,1-3-2.824V24.706m24,0V19.059a2.916,2.916,0,0,0-3-2.824H19a2.916,2.916,0,0,0-3,2.824v5.647m16.5-8.471V14.824A2.916,2.916,0,0,0,29.5,12h-3a2.916,2.916,0,0,0-3,2.824v1.412",
    transform: "translate(-16 -12)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobOrder);
export default __webpack_public_path__ + "static/media/job-order.1c6892ea3aa8f2b80338068f2069d080.svg";
export { ForwardRef as ReactComponent };